import { ShieldCheck, Headphones, Award, Sparkles } from "lucide-react";

const PROPS = [
  { icon: ShieldCheck, title: "Verified Curated Properties", body: "Every property is personally visited, vetted and photographed before it goes on Appy Stays. No surprises." },
  { icon: Headphones, title: "Dedicated Booking Assistance", body: "A real human host desk replies in under 30 minutes. WhatsApp, calls, email — they handle it all." },
  { icon: Award, title: "Appy Managed Premium Collection", body: "10 signature properties run end-to-end by us — staff, decor, food, music. Hotel-grade, farmhouse pricing." },
  { icon: Sparkles, title: "Experiences Beyond Stay", body: "Add a chef, DJ, decor, photographer, yoga teacher — anything your celebration needs, in one quote." },
];

export default function WhyAppy() {
  return (
    <section className="bg-[#FAFAF8] py-20 md:py-24" data-testid="why-appy-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
          <div>
            <div className="kicker mb-3">Why Appy Stays</div>
            <h2 className="font-sora text-3xl md:text-4xl font-semibold tracking-tight text-[#0E2E24] max-w-2xl leading-tight">
              Built for celebrations. Trusted by hosts.
            </h2>
          </div>
          <p className="max-w-sm text-[#5B6B63] font-sora">
            Four reasons people pick Appy Stays over a generic listing site or last-minute resort.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {PROPS.map((p, i) => (
            <div
              key={p.title}
              className="bg-white border border-[#0E2E24]/10 rounded-2xl p-7 hover-lift"
              data-testid={`why-appy-${i}`}
            >
              <div className="h-11 w-11 rounded-xl bg-[#E8F2EC] flex items-center justify-center">
                <p.icon size={20} className="text-[#1F5A43]" />
              </div>
              <h3 className="mt-6 font-sora text-lg font-semibold text-[#0E2E24] leading-tight">{p.title}</h3>
              <p className="mt-3 text-sm text-[#5B6B63] leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
